import Env from '../base/env';
import Channels from '../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap'
import drawSVG from '../vendor/gsap-bonus-umd/DrawSVGPlugin'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(drawSVG)
gsap.registerPlugin(ScrollTrigger)
import { CountUp } from 'countup.js';

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.arcPath = this.ref.arc[0].querySelector('path')
    this.DOM.anchorInTheFlow = this.DOM.view.parentElement.querySelector('.interactive-datas-anchor')
    // Options
    //! VARS
    this.VARS = {}
    this.VARS.PADDING_CIRCLE = 200
    this.VARS.FEATURES_SIZE = 15
    this.VARS.NEW_SLIDE = 0
    this.VARS.CURRENT_SLIDE = -1
    this.VARS.SIZE_SCROLL = 2000
    this.TOTAL_SLIDES = this.ref.anchor.length - 1
    this.VARS.skinValue = this.DOM.view.getAttribute('data-skin')
    //! Fns
    this.makeCircle()
    this.makeAnchors()
    this.funcResize = this.resize.bind(this)
    Channels.on('window::smartresize',this.funcResize)
    this.events()
    gsap.set(this.DOM.arcPath,{ drawSVG:"0%" })
    this.makeSticky();
    this.prepareDatas()
    this.go(this.VARS.NEW_SLIDE)
  }

  drawAnchor(el)
  {
    const angle = el.getAttribute('data-angle') * 1
    const rad = Math.radians(angle - 90)
    const x = Math.cos(rad) * this.VARS.RADIUS + (this.VARS.CENTER_CIRCLE - this.VARS.FEATURES_SIZE/2)
    const y = Math.sin(rad) * this.VARS.RADIUS + (this.VARS.CENTER_CIRCLE - this.VARS.FEATURES_SIZE/2)
    gsap.set(el,{ x: x, y : y  })
  }

  events()
  {

    for (const [i, anchor] of this.ref.anchor.entries()) {
      anchor.addEventListener('click',()=>{
        this.moveScroll(i)
      })
    }
    for (const [i, anchor] of this.ref.anchorMobile.entries()) {
      anchor.addEventListener('click',()=>{
        this.moveScroll(i)
      })
    }
  }

  go()
  {
    for (const [i, anchor] of this.ref.anchor.entries()) {
      anchor.classList.remove('is-active')
      anchor.classList.remove('is-prev')
      this.ref.anchorMobile[i].classList.remove('is-active')
      this.ref.anchorMobile[i].classList.remove('is-prev')
      this.ref.data[i].classList.remove('is-active')
      for(let anim of this.animNumbers[i]) {
        anim.reset()
      }
      if(i < this.VARS.NEW_SLIDE) {
        anchor.classList.add('is-prev')
        this.ref.anchorMobile[i].classList.add('is-prev')
      }
    }
    this.ref.anchor[this.VARS.NEW_SLIDE].classList.add('is-active')
    this.ref.anchorMobile[this.VARS.NEW_SLIDE].classList.add('is-active')
    this.ref.data[this.VARS.NEW_SLIDE].classList.add('is-active')

    for(let anim of this.animNumbers[this.VARS.NEW_SLIDE]) {
      anim.start()
    }
    this.VARS.CURRENT_SLIDE = this.VARS.NEW_SLIDE
  }

  listener(st)
  {
    let steps = []
    const limit =  1 / this.ref.anchor.length
    for (const [i, item] of this.ref.anchor.entries()) {
      const limitMin = i * limit
      const limitMax = (i+1) * limit
      if(st.progress >= limitMin && st.progress < limitMax) {
        this.VARS.NEW_SLIDE = i
      }
    }
  }

  makeAnchors()
  {
    for(let anchor of this.ref.anchor) {
      this.drawAnchor(anchor)
    }
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      end:`+=${this.VARS.SIZE_SCROLL}px`,
      pin:true,
      pinSpacing:true,
      invalidateOnRefresh: true,
      onUpdate:(e)=>{
        this.listener(e)
        if(this.VARS.NEW_SLIDE != this.VARS.CURRENT_SLIDE) {
          this.go()
        }
        gsap.set(
          this.DOM.arcPath,
          {
            drawSVG:`${e.progress * -100}%`
          }
        )
        gsap.set(
          this.ref.progressionMobile,
          {
            transformOrigin:'left top',
            scaleY:e.progress
          }
        )
      }
    })
    // Skin change
    this.stSkin = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top+=60px',
      end: ()=>{
        const viewport = Env.framework.toolbox.getViewport()
        return `+=${this.VARS.SIZE_SCROLL + viewport.height}px`
      },
      pin:false,
      pinSpacing:false,
      invalidateOnRefresh: true,
      markers:false,
      onEnter:()=>{
        Env.$html.classList.add(this.VARS.skinValue)
      },
      onEnterBack:()=>{
        Env.$html.classList.add(this.VARS.skinValue)
      },
      onLeave:()=>{
        Env.$html.classList.remove(this.VARS.skinValue)
      },
      onLeaveBack:()=>{
        Env.$html.classList.remove(this.VARS.skinValue)
      }
    })
  }


  makeCircle()
  {
    this.dimensions = this.ref.containerCircle[0].getBoundingClientRect()

    this.VARS.SVG_SIZE = this.dimensions.height - this.VARS.PADDING_CIRCLE
    this.VARS.CENTER_CIRCLE = this.VARS.SVG_SIZE/2
    this.VARS.RADIUS = this.VARS.SVG_SIZE*1/2

    gsap.set(this.ref.circle, { width : this.VARS.SVG_SIZE, height:this.VARS.SVG_SIZE })
    gsap.set(this.ref.arc, { width: this.VARS.CENTER_CIRCLE + 1 })
  }

  moveScroll(index)
  {
    const posY = this.DOM.anchorInTheFlow.getBoundingClientRect().top + Env.framework.toolbox.scrollPosition().scrollY
    const ratioMove = this.VARS.SIZE_SCROLL / (this.ref.anchor.length - 1)
    gsap.to(window, {
      scrollTo: (ratioMove*index)+posY,
      duration: 1,
      ease:'quint.out'
    });
  }

  resize()
  {
    this.makeCircle()
    setTimeout(() => {
      this.makeAnchors()
    }, 100);
  }

  detectOptions(number)
  {
    let numberToAnim = number
    let whichSeparator = false
    const numberStr = number.toString()
    let options = {
      useGrouping:true
    }
    // Detect period
    if(numberStr.indexOf('.') > 0) {
      whichSeparator = '.'
    }
    // Detect comma
    if(numberStr.indexOf(',') > 0) {
      whichSeparator = ','
      numberToAnim = number.replace(',','.')
      options.decimal = ','
      options.separator = '';
    }
    // Detect x
    if(numberStr.indexOf('x') > 0) {
      whichSeparator = 'x'
      options.separator = 'x'
      numberToAnim = number.replace('x','')
    }

    if(whichSeparator == '.' || whichSeparator == ',') {
      const separator = numberStr.split(whichSeparator)
      options.decimalPlaces = separator[1].length - 1
    }
    options.numberToAnim = numberToAnim*1

    return options
  }

  prepareDatas()
  {
    this.animNumbers = []
    for (const [i, data] of this.ref.data.entries()) {
      this.animNumbers[i] = []
      const paragraphs = data.querySelectorAll('p')
      for(let str of paragraphs) {
        const number = str.innerHTML.split('[')
        const options = this.detectOptions(number[0])
        options.suffix = ' <span class="suffix tw-font-fix-lt tw-uppercase tw-text-base lg:tw-text-[30px] xl:tw-text-[43px]">'+number[1].replace(']','')+'</span>'
        options.startVal = false
        options.duration = 2
        const instance = new CountUp(str,options.numberToAnim,options)
        this.animNumbers[i].push(instance)
      }
    }

  }

  unmount()
  {
    Channels.removeListener('window::smartresize',this.funcResize)
    this.sticky.kill()
    this.stSkin.kill()
  }
}
